"use client";

import dynamic from "next/dynamic";

const ClientOnlyResourceAssetIndex = dynamic(
  () => import("@/templates/ResourceAssetIndex"),
  {
    ssr: false,
    loading: () => <div className="min-h-[600px]" aria-hidden="true" />,
  },
);

export default ClientOnlyResourceAssetIndex;
